import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// export type State = {
//     sampleData: Array,
//     isLoading: Boolean,
//     isMobile: Boolean,
//     popup: Object,
// }

const defaultState = {
    // sampleData: [],
    isMusicPlayed: false,
    isLoading: true,
    isMobile: null,
    popup: null,
    popupQueue: null,
    showParticlesWave: false,
    author: null,
    // cover: null,
    mid: null,
    songData: null,
    videoUrl: null,
    // isJump: false,
    // jumpTarget: null,
}

const getters = {
    // sampleList: ({ sampleData }) => {
    //     return sampleData.filter(item => {
    //         /* ... */
    //     });
    // }
};

const mutations = {
    setMusicPlayed(state, value) {
        state.isMusicPlayed = value;
    },
    setLoading(state, value) {
        state.isLoading = value;
    },
    setMobile(state, value) {
        state.isMobile = value;
    },
    setPopup(state, value) {
        state.popup = value;
    },
    setPopupQueue(state, value) {
        state.popupQueue = value;
    },
    setParticlesWave(state, value) {
        state.showParticlesWave = value;
    },
    setAuthor(state, value) {
        state.author = value;
    },
    // setCover(state, value) {
    //     state.cover = value;
    // },
    setMid(state, value) {
        state.mid = value;
    },
    setSongData(state, value) {
        state.songData = value;
    },
    setVideoUrl(state, value) {
        state.videoUrl = value;
    },
    // setJump(state, value) {
    //     state.isJump = value;
    // },
    // setJumpTarget(state, value) {
    //     state.jumpTarget = value;
    // },
}

const actions = {
    toggleMusicPlayed({ commit }, bool) {
        commit('setMusicPlayed', bool);
    },
    toggleLoading({ commit }, bool) {
        commit('setLoading', bool);
    },
    toggleMobile({ commit }, bool) {
        commit('setMobile', bool);
    },
    openPopup({ commit }, payload) {
        commit('setPopup', payload);
    },
    closePopup({ commit }) {
        commit('setPopup', null);
    },
    savePopupQueue({ commit }, payload) {
        commit('setPopupQueue', payload);
    },
    clearPopupQueue({ commit }) {
        commit('setPopupQueue', null);
    },
    toggleParticlesWave({ commit }, bool) {
        commit('setParticlesWave', bool);
    },
    saveAuthor({ commit }, payload) {
        commit('setAuthor', payload);
    },
    // saveCover({ commit }, payload) {
    //     commit('setCover', payload);
    // },
    saveMid({ commit }, payload) {
        commit('setMid', payload);
    },
    saveSongData({ commit }, payload) {
        commit('setSongData', payload);
    },
    saveVideoUrl({ commit }, payload) {
        commit('setVideoUrl', payload);
    },
    resetData({ commit }) {
        commit('setParticlesWave', false);
        commit('setAuthor', null);
        commit('setMid', null);
        commit('setSongData', null);
        commit('setVideoUrl', null);
    }
    // toggleJump({ commit }, bool) {
    //     commit('setJump', bool);
    // },
    // saveJumpTarget({ commit }, payload) {
    //     commit('setJumpTarget', payload);
    // },
    // clearJumpTarget({ commit }) {
    //     commit('setJumpTarget', null);
    // },
};

const modules = {};

export default new Vuex.Store({
    state:      defaultState,
    getters:    getters,
    mutations:  mutations,
    actions:    actions,
    modules:    modules
});